import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-bs-target"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered mw-800px" }
const _hoisted_4 = { class: "modal-content umt-form" }
const _hoisted_5 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-4 px-lg-8" }
const _hoisted_10 = { class: "notice d-flex align-items-center bg-light-primary rounded border-primary border border-dashed p-4 mb-7" }
const _hoisted_11 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-gray-700" }, [
  /*#__PURE__*/_createTextVNode("Chọn "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-gray-900" }, "khoa"),
  /*#__PURE__*/_createTextVNode(" & "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-gray-900" }, "ngành nhập học"),
  /*#__PURE__*/_createTextVNode(", kèm "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-gray-900" }, "học bổng"),
  /*#__PURE__*/_createTextVNode(" (nếu có) để tạo mã sinh viên cho ứng viên này.")
], -1)
const _hoisted_13 = { class: "row g-5" }
const _hoisted_14 = { class: "col-md-4 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Khoa", -1)
const _hoisted_16 = { class: "col-md-4 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Ngành đăng ký học bổng", -1)
const _hoisted_18 = { class: "col-md-4 fv-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Học bổng đăng ký", -1)
const _hoisted_20 = { class: "d-flex justify-content-end gap-3 mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-success me-3 d-none",
      ref: "call_modal",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${_ctx.id}`
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.id,
      ref: "addChooseApp",
      tabindex: "-1"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                ]),
                _hoisted_12
              ]),
              _createVNode(_component_el_form, { model: _ctx.formData }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_el_form_item, { prop: "school" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "popper-class": "umt-form-dd",
                            class: "form-select-solid w-100",
                            placeholder: "Chọn khoa",
                            filterable: true,
                            modelValue: _ctx.formData.school,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.school) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrSchool, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_el_form_item, { prop: "admissionmajorcode" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "popper-class": "umt-form-dd",
                            class: "form-select-solid w-100",
                            placeholder: "Chọn ngành",
                            filterable: true,
                            onChange: _ctx.changeAdMajor,
                            modelValue: _ctx.formData.admissionmajorcode,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.admissionmajorcode) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajor, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.name,
                                  value: item.code
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_el_form_item, { prop: "scholarshipregistration" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "popper-class": "umt-form-dd",
                            class: "form-select-solid w-100",
                            placeholder: "Chọn học bổng",
                            filterable: true,
                            modelValue: _ctx.formData.scholarshipregistration,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.scholarshipregistration) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrScholarship, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: `${item.name} (${item.code})`,
                                  value: item.code
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["model"]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn btn-light",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal()))
                }, " Hủy bỏ "),
                _createElementVNode("button", {
                  class: "btn btn-success",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitComment()))
                }, " Tạo mã SV ")
              ])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_2)
  ], 64))
}